import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
import { BackdropStyled } from './CircularProgressBackdrop.styled';
const CircularProgressBackdrop = (props) => {
    return (_jsx(BackdropStyled, { ...props, children: _jsx(CircularProgress, { color: "inherit" }) }));
};
export { CircularProgressBackdrop };
